var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 19.7719C39.5 30.028 30.7913 38.3807 20 38.3807C9.20872 38.3807 0.5 30.028 0.5 19.7719C0.5 9.51576 9.20872 1.16309 20 1.16309C30.7913 1.16309 39.5 9.51576 39.5 19.7719Z",
    stroke: "black",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9242 14.6421C27.5232 14.0697 27.5232 13.1305 26.9242 12.5582C26.3251 11.9858 25.3575 11.9858 24.7431 12.5582L19.6896 17.4011L14.6362 12.5728C14.0371 12.0005 13.0695 12.0005 12.4551 12.5728C11.8407 13.1452 11.856 14.0697 12.4551 14.6568L17.5239 19.4704L12.4704 24.3133C11.8714 24.8856 11.8714 25.8102 12.4704 26.3972C13.0695 26.9842 14.0371 26.9696 14.6515 26.3972L19.6896 21.5543L24.7584 26.3825C25.3575 26.9549 26.3251 26.9549 26.9395 26.3825C27.5539 25.8102 27.5386 24.8856 26.9395 24.2986L21.8707 19.4704L26.9242 14.6421Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.07499ce74d10e6204ffb0f3b1721bdb8.svg";
export { ForwardRef as ReactComponent };